/**
 * JBC CUSTOMIZATION: Hide ReCharge subscription widget based on variant metafields
 * Expose the mapping to a JS-friendly data attribute (already rendered above).
 * Minimal client script below uses only evt.detail.resource and this server-rendered map.
 */

/* Minimal, production-ready handler: use only evt.detail.resource + server-rendered variant map */
(function () {
  if (typeof window === 'undefined') return;

  var wrapper = document.querySelector('[data-jbc-product-details]');
  if (!wrapper) return; // Exit if block isn't present

  var SECTION_ID = wrapper.getAttribute('data-section-id') || '';

  // Parse server-rendered variant map (liquid produced JSON in data attribute)
  var variantMap = {};
  if (wrapper) {
    var attr = wrapper.getAttribute('data-jbc-hide-subscription-map');
    if (attr) {
      try {
        variantMap = JSON.parse(attr);
      } catch (e) {
        // If parsing fails, variantMap remains empty
        variantMap = {};
      }
    }
  }

  function shouldHideFromResource(resource) {
    if (!resource) return false;

    // 1) explicit metafield on the resource
    if (resource.metafields && resource.metafields.custom &&
       (resource.metafields.custom.hide_subscription_option === true || resource.metafields.custom.hide_subscription_option === 'true')
    ) {
      return true;
    }

    // 2) server-rendered variant map lookup by id (string or number)
    var vid = String(resource.id || resource.variant_id || '');
    if (vid && typeof variantMap[vid] !== 'undefined' && variantMap[vid]) {
      return true;
    }

    // 3) treat unavailable variants as sold out
    if (typeof resource.available !== 'undefined' && resource.available === false) {
      return true;
    }

    return false;
  }

  function onVariantEvent(evt) {
    // Only act when the event includes a resource object (this is the approach that worked)
    var resource = evt && evt.detail && evt.detail.resource;
    if (!resource) return;

    var hide = shouldHideFromResource(resource);

    var sectionId = (evt && evt.detail && evt.detail.sectionId) || SECTION_ID;
    var detailsBlock = document.getElementById('ProductInformation-' + sectionId);
    if (!detailsBlock) detailsBlock = document.querySelector('.product-details');
    if (!detailsBlock) return;

    detailsBlock.classList.toggle('recharge-widget-hidden', !!hide);
  }

  // Listen to the specific events observed in your environment
  ['variant:selected','variant:update'].forEach(function (name) {
    document.addEventListener(name, onVariantEvent);
    document.addEventListener(name, onVariantEvent, true);
  });
})();

/* Script to add .recharge-has-ui when ReCharge widget renders content */
(function () {
  if (typeof window === 'undefined') return;

  function checkAndMarkWidget() {
    var widgets = document.querySelectorAll('.shopify-app-block.recharge-subscription-widget');
    if (!widgets.length) return;

    widgets.forEach(function(widget) {
      if (widget.classList.contains('recharge-has-ui')) return; // Already marked

      var rechargeElement = widget.querySelector('recharge-subscription-widget');
      if (!rechargeElement) return;

      // Check multiple indicators that content has loaded:
      // 1. Has children
      // 2. Has computed height > 0
      // 3. Has specific ReCharge UI elements
      var hasChildren = rechargeElement.children.length > 0 ||
                       rechargeElement.childNodes.length > 0;
      var hasHeight = rechargeElement.offsetHeight > 0;
      var hasContent = rechargeElement.shadowRoot ||
                      rechargeElement.querySelector('[class*="recharge"]') ||
                      hasChildren;

      if (hasContent || hasHeight) {
        widget.classList.add('recharge-has-ui');
      }
    });
  }

  // Check immediately in case it's already loaded
  checkAndMarkWidget();

  // Use MutationObserver on document to catch when widget appears or changes
  var observer = new MutationObserver(function(mutations) {
    checkAndMarkWidget();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  // Also check on load and after short delays
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndMarkWidget);
  }

  window.addEventListener('load', checkAndMarkWidget);

  // Retry checks at intervals for slow-loading widgets
  var checks = 0;
  var maxChecks = 10;
  var checkInterval = setInterval(function() {
    checkAndMarkWidget();
    checks++;
    if (checks >= maxChecks) {
      clearInterval(checkInterval);
      observer.disconnect();
    }
  }, 500);
})();
